<template>

  <div class="px-0">
    <div class="row no-gutters mb-3 mt-3">
      <div class="col-md-12 col-sm-12" v-if="types[access] == 'Provident'">
        <h4 class="atlhr-dashboard-title mt-10">
          Provident Fund Board of Trustee Management Documents <span class="black-title"></span>
          <span>
            <a v-bind:href="$api_url+'/'">Dashboard</a>
              / PF BoT Management Documents
          </span>
        </h4>
      </div> 
      <div class="col-md-12 col-sm-12" v-if="types[access] == 'Gratuity'">
        <h4 class="atlhr-dashboard-title mt-10">
          Gratuity Fund Board of Trustee Management Documents <span class="black-title"></span>
          <span>
            <a v-bind:href="$api_url+'/'">Dashboard</a>
              / GF BoT Management Documents
          </span>
        </h4>
      </div>
    </div>
    <div class="ibox col-md-12 border-0">
      <!-- <div class="row no-gutters py-2 mb-3 border-bottom mt-4"> --> <!-- Rejwan: 09-09-2025 ACL -->
      <div class="row no-gutters py-2 mb-3 border-bottom mt-4"> <!-- Rejwan: 09-09-2025 ACL -->
        <div class="col-md-12">
          <h4 class="mb-2 pb-2 border-bottom pb-2 mt-2">{{ types[access] }} Fund Trustee Board Documents Portal </h4>
          <div class="clearfix">
              <p style="font-size: 15px;" class='float-left'>Store and maintain all documents regarding your {{ types[access] }} Fund and its relative activities.</p>
          </div>
        </div>

        <div class="col-md-3">
          <div>
            <div>
              <b-button v-b-toggle.collapse-1 variant="link" class="text-decoration-none" @click="init()">
                <b-icon icon="folder" class="mr-2"></b-icon> Home
              </b-button>
            </div>

              <div>
                  <div v-for="node in allFolders" :key="node.id">
                      <b-button
                          v-b-toggle="'collapse-' + node.id"
                          variant="link"
                          class="text-decoration-none long-button-name-bot"
                          @click="toggle(node.id, node.file_type)"
                      >
                          <b-icon style="transform: rotate(270deg);" :icon="collapsed[node.id] ? 'chevron-left' : 'chevron-down'" />
                        <b v-if="selectedFolderId == node.id">{{ node.name }}</b>
                          <span v-else>{{ node.name }}</span>

                      </b-button>

                      <b-collapse :id="'collapse-' + node.id" v-model="collapsed[node.id]" class="ml-3">
                          <folder-children :selectedFolderId="selectedFolderId" :nodes="node.children" :collapsed="collapsed" @toggle="toggle" />
                      </b-collapse>
                  </div>
              </div>

            <div v-for="folder in folders" :key="folder.id">
              <b-button v-b-toggle="'collapse-' + folder.id" variant="link" class="text-decoration-none" @click="toggle(folder.id, folder.file_type)">

                <b-icon :icon="parent_collapsed[folder.id] ? 'chevron-down' : 'chevron-right'" class="mr-2"></b-icon>
                <b-icon :icon="parent_collapsed[folder.id] ? 'folder2-open' : 'folder'" class="mr-2"></b-icon>

                <span v-b-tooltip.hover.right :title="folder.trustee_list" v-if="is_truestee.trustee_member != 'no'">
                  {{ folder.name }}
                </span>
                <span v-else>{{ folder.name }}</span>

              </b-button>
            </div>
          </div>
        </div>


        <div class="col-md-9 pr-3">
          <div class="row">
            <div class="col-sm-6 pl-0 company-form-box-title">
              <div class="custom-search">
                  <b-input-group class="mb-2">
                      <b-input-group-prepend is-text>
                          <b-icon icon="search"></b-icon>
                      </b-input-group-prepend>
                      <b-form-input autocomplete="off" name="search" placeholder="Search" v-model="search" @input="resetPagination()"></b-form-input>
                  </b-input-group>
              </div>
            </div>
            <div class="col-sm-6 pr-0 cursor-pointer text-right company-form-box-title" v-if="is_truestee.trustee_member != 'no'">
<!--                <b-button v-if="selectedFolderId" @click="updateFolder()"><b-icon icon="folder-plus" class="mr-2"></b-icon> Update Folder </b-button>-->
                <!-- <b-button @click="showFolder()"><b-icon icon="folder-plus" class="mr-2"></b-icon> Create Folder</b-button> --> <!-- Rejwan: 09-09-2025 ACL -->
                <template v-if="$acl[access+'/filemanagement'] == 2">
                  <b-button @click="showFolder()"><b-icon icon="folder-plus" class="mr-2"></b-icon> Create Folder</b-button> <!-- Rejwan: 09-09-2025 ACL -->
                <!-- <b-button v-if="selectedFolderId" @click="uploadFiles()"><b-icon icon="file-earmark-plus" class="mr-2"></b-icon> Upload File</b-button> --> <!-- Rejwan: 09-09-2025 ACL -->
                  <b-button v-if="selectedFolderId" @click="uploadFiles()"><b-icon icon="file-earmark-plus" class="mr-2"></b-icon> Upload File</b-button> <!-- Rejwan: 09-09-2025 ACL -->
                </template>
            </div>
            <table class="table dataTable">
              <thead>

                <tr class="table-head">
                  <th v-for="column in columns" :key="column.name" @click="sortBy(column.name)" :class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'" style="cursor:pointer;"><span>{{column.label}}</span></th>
                  <th class="text-center" v-if="$acl[access+'/filemanagement'] == 2">Action</th>
                </tr>
              </thead>

              <tbody>

                <tr class="hover-bg table-row border-bottom mx-2" v-for="file in paginatedData" :key="file.id">
                  <td v-if="file.file_type === 'Folder'" class="leave-reason-wrapper"><span @click="toggle(file.id, file.file_type)" class="d-block cursor-pointer">{{ file.name }}</span></td> <td v-else>{{ file.name }}</td>
                  <td v-if="file.file_type=='Folder'"> <span class="d-block cursor-pointer">{{ file.uploaded_by }}</span> </td> <td v-else>{{ file.uploaded_by }}</td>
                  <td v-if="file.file_type=='Folder'"> <span class="d-block cursor-pointer">{{ file.file_type }}</span> </td> <td v-else>{{ getFileType(file.file_type)   }}</td>
                  <td v-if="file.file_type=='Folder'"> <span class="d-block cursor-pointer text-center">-</span> </td> <td class="text-right" v-else>{{ parseFloat(file.file_size / 1000).toFixed(2) }} KB</td>
                  <td v-if="file.file_type=='Folder'"> <span class="d-block cursor-pointer">{{ formatDate(file.last_modified) }}</span> </td> <td v-else>{{ formatDate(file.last_modified) }}</td>
                  <td class="" v-if="$acl[access+'/filemanagement'] == 2">
                    <div class="position-relative float-right" v-if="is_truestee.trustee_member != 'no'">
                      <b-button-toolbar>
                        <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                        <div class="dropdown-menu action-dropdown-menu px-0 py-1" aria-labelledby="actionDropdown">
                          <b-button-group>
                            <b-button v-if="file.file_type!='Folder'" variant="outline-secondary" @click="downloadFile(file.id)"> <b-icon icon="download"></b-icon> Download </b-button>
                            <!-- <b-button v-if="file.file_type=='Folder'" variant="outline-secondary" @click="updateFolder(file.id)"> <b-icon icon="folder2-open"></b-icon> Edit Folder </b-button> --> <!-- Rejwan: 09-09-2025 ACL -->
                            <b-button v-if="file.file_type=='Folder'" variant="outline-secondary" @click="updateFolder(file.id)"> <b-icon icon="pencil"></b-icon> Edit Folder </b-button> <!-- Rejwan: 09-09-2025 ACL -->
                            <!-- <b-button variant="outline-secondary" @click="showDeleteModal(file)"> <b-icon icon="trash"></b-icon> Delete </b-button> --> <!-- Rejwan: 09-09-2025 ACL -->
                            <b-button variant="outline-secondary" @click="showDeleteModal(file)"> <b-icon icon="trash"></b-icon> Delete </b-button> <!-- Rejwan: 09-09-2025 ACL -->
                          </b-button-group>
                        </div>
                      </b-button-toolbar>
                    </div>

                    <div v-else>
                      <b-button @click="downloadFile(file.id)"> <b-icon icon="download" class="mr-2"></b-icon> Download </b-button>
                    </div>
                  </td>
                </tr>
                
                <tr v-if="paginatedData.length == 0" class="text-center border">
                  <td :colspan="6" v-if="data !== ''">{{ blankmsg }}</td>
                </tr>

              </tbody>
            </table>

            <div v-if="paginatedData.length > 0" class="w-100">
                  
              <div class="row py-2 no-margin float-left" v-if="paginatedData.length > 0">
                <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">
                    <ul class="pagination b-pagination float-left mb-0 mt-1">
                        <li class="page-item disabled m-2">View</li>
                        <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                        <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                    </ul>
                    <!-- <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav> -->
                </div>

              </div>

              <div class="row p-2 float-right" >
                <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
              </div>
                  

                  <!-- <td :colspan="6">
                    <div class="row p-2 float-right" >
                      <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" first-number last-number ></b-pagination-nav>
                    </div>
                  </td> -->
            </div>

          </div>

        </div>

      </div>
      <!-- Start: Rejwan: 09-09-2025 ACL -->
<!--      <div class="py-2 mt-4" v-else>-->
<!--        <p><b>Sorry, you don't have access</b></p>-->
<!--      </div>-->
      <!-- End: Rejwan: 09-09-2025 ACL -->
    </div>

    <b-modal id="bv-modal-create-folder" body-class="pt-0" header-class="mb-2" size="md" hide-footer :title="modalTitle">

      <b-overlay :show="showoverlaymodal" rounded="sm">
        <form @submit.prevent="createFolder">
          <b-form-group id="folder_name-group" class="required-field" label="Folder Name" label-for="folder_name">
              <b-form-input id="folder_name" name="folder_name" v-model="newFolderName" v-validate="{ required: true, min: 3, max: 100, regex: /^[A-Za-z0-9 ._\-()&]+$/ }" :state="validateState('folder_name')" aria-describedby="folder_name-feedback" data-vv-as="Folder Name"></b-form-input>
              <b-form-invalid-feedback id="folder_name-feedback">{{ veeErrors.first('folder_name') }}</b-form-invalid-feedback>
          </b-form-group>

          <!-- <b-form-group id="select_folder-group" class="half-width d-none" label="Select Folder" label-for="select_folder" >
              <b-form-select id="select_folder" name="select_folder" v-model="parentId" v-validate="{ required: true }" :options="folderOptions" :state="validateState('select_folder')" aria-describedby="select_folder-feedback" data-vv-as="Select Folder"></b-form-select>
              <b-form-invalid-feedback id="select_folder-feedback">{{ veeErrors.first('select_folder') }}</b-form-invalid-feedback>
          </b-form-group> -->

          <div class="d-none" v-if="selectedFolderId==null">
              <div>
                  <b-form-group label="Trustee Members" v-slot="{ ariaDescribedby }">
                      <b-form-checkbox switch v-model="trusteeIsSelected"></b-form-checkbox>
                  </b-form-group>
              </div>

              <div v-if="!trusteeIsSelected">
                  <b-form-group v-if="departments_option.length > 0">
                      <template #label>
                          <b>Departments:</b><br>
                          <b-form-checkbox v-model="allSelected" :indeterminate="indeterminate"
                                           aria-describedby="departments" aria-controls="departments" @change="toggleAll">
                              {{ allSelected ? 'Un-select All' : 'Select All' }}
                          </b-form-checkbox>
                      </template>

                      <template v-slot="{ ariaDescribedby }">
                          <b-form-checkbox-group id="departments" v-model="selected" :options="departments_option"
                                                 :aria-describedby="ariaDescribedby" name="departments" class="ml-4"
                                                 aria-label="Individual departments" stacked></b-form-checkbox-group>
                      </template>
                  </b-form-group>
              </div>
          </div>

          <div class="full-width text-center mt-3">
            <b-button type="submit" variant="primary" >{{ editMode ? 'Update' : 'Add' }}</b-button>
          </div>
          

        </form>
      </b-overlay>
    </b-modal>


    <!-- <b-modal id="delete-modal" title="Are you sure you want to delete this Field?" hide-footer>                    
      <div class="btn-wrapper text-center pt-5">
          <a href="javascript:void(0);" class="btn btn-primary"  @click="removeEntry(current_header_type,current_row)">Delete <span v-if="loading != ''"><img :src="this.pageurl+'/public/images/loading.gif'" width="20"></span></a>
          &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary" block @click="$bvModal.hide('delete-modal')">Cancel</a>
      </div>
      <div style="height: 5px;clear:both;"> &nbsp;</div>
    </b-modal> -->

    <b-modal id="delete-modal" :title="`Are you sure you want to delete this ${selectedForDelete ? (selectedForDelete.file_type == 'Folder' ? 'folder' : 'file') : ''}?`" hide-footer>
      
      <div v-if="hasChildren" class="d-flex flex-column justify-content-center align-items-center">
        <!-- <div>
          <div>
            <span class="h1 text-danger">
                <b-icon icon="exclamation-triangle-fill"></b-icon>
            </span>
            <span class="text-danger h4">Disclaimer </span>
          </div>
          <p class="my-3">
            Folder must be empty before it can be deleted.
            <br> Please delete all containing files and folders to proceed.
          </p>
        </div> -->
        <div class="row mt-2">
            <div class="col-md-2 text-right">
              <b-icon icon="exclamation-triangle" style="width: 70px; height: 70px;" variant="danger" class="align-custom"></b-icon>
            </div>
            <div class="col-md-10 d-flex justify-content-center flex-column">
              <h5 class="mb-2 text-danger">Disclaimer</h5>
              <p class="mb-0 text-secondary mb-4">Folder must be empty before it can be deleted. Please delete all containing files and folders to proceed.</p>
            </div> 
        </div>
        <b-button @click="$bvModal.hide('delete-modal')">Okay</b-button>
      </div>
      <div v-if="!hasChildren && selectedForDelete != null">

        <div class="">
          <!-- <span class="h1 text-danger">
              <b-icon icon="trash-fill"></b-icon>
          </span> -->
          <!-- <p class="text-center">Are you sure you want to delete this {{selectedForDelete.file_type == 'Folder' ? 'folder' : 'file' }}?</p> -->
          <p class="mb-2 mt-2 border-bottom pb-2">*{{selectedForDelete.name}}* will be permanently deleted.</p>
          
        </div>
        <div class="text-right mt-3">
          <b-button class="" @click="deleteFile(selectedForDelete, password)" variant="primary">Confirm Delete<span v-if="loading != ''"><img :src="$api_url+'/images/loading.gif'" width="20"></span></b-button>
          <b-button class="" @click="$bvModal.hide('delete-modal')" variant="primary">Cancel</b-button>
        </div>

      </div>
    </b-modal>


    <b-modal  id="delete-modal111" title="" hide-footer>

        <div v-if="hasChildren" class="d-flex flex-column justify-content-center align-items-center pb-5">
                <div>
                    <div>
                    <span class="h1 text-danger">
                        <b-icon icon="exclamation-triangle-fill"></b-icon>
                    </span>
                        <span class="text-danger h4">Disclaimer </span>
                    </div>
                    <p class="my-3">
                        Folder must be empty before it can be deleted.
                        <br> Please delete all containing files and folders to proceed.
                    </p>
                </div>
                <b-button @click="$bvModal.hide('delete-modal')">Okay</b-button>
            </div>
            <div v-if="!hasChildren && selectedForDelete != null" class="py-5">

                <div class="d-flex flex-column justify-content-center align-items-center">
                <span class="h1 text-danger">
                    <b-icon icon="trash-fill"></b-icon>
                </span>
                    <p class="text-center">Are you sure you want to delete this {{selectedForDelete.file_type == 'Folder' ? 'folder' : 'file' }}?</p>
                    <p class="mb-2 mt-2">*{{selectedForDelete.name}}*</p>
<!--                    <b-form-group id="password-group" label="Please enter your password to continue:" label-for="password">-->
<!--                        <b-form-input id="password" name="password" type="password" tyconsole.lope="password" v-model="password" :state="validateState('password')" aria-describedby="password-feedback" data-vv-as="Tax Rate on Cash Dividend"></b-form-input>-->
<!--                        <b-form-invalid-feedback id="password-feedback">{{ veeErrors.first('password') }}</b-form-invalid-feedback>-->
<!--                    </b-form-group>-->
                    <div class="d-flex row justify-content-center align-items-center">
                        <b-button @click="deleteFile(selectedForDelete, password)" variant="danger">Confirm Delete<span v-if="loading != ''"><img :src="$api_url+'/images/loading.gif'" width="20"></span></b-button>
                        <b-button @click="$bvModal.hide('delete-modal')" variant="success-outline">Cancel</b-button>
                    </div>
                </div>

            </div>
    </b-modal>

    <b-modal id="bv-modal-upload-file" body-class="pt-0" header-class="mb-2" size="md" hide-footer title="Upload New File">

      <b-overlay :show="showoverlaymodal" rounded="sm">
        <div>
          <form @submit.prevent="uploadFile">

            <!-- <b-form-group id="file-group" label="File" label-for="file">
                <b-form-file id="file" placeholder="Choose a file or drop it here..." ref="fileInput" drop-placeholder="Drop file here..." aria-describedby="file-feedback" data-vv-as="File"></b-form-file>
            </b-form-group> -->

            <b-form-group id="fileInput-group" label="File" label-for="fileInput" class="required-field">                                      
                <b-form-file @change="checkFileType($event , 'fileInput' , ['.jpg', '.gif' , '.png' ,'.pdf' , '.doc' , '.xls'])" ref="fileInput" id="fileInput" accept=".jpg, .png, .gif, .pdf , .doc , .xls"  placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." ></b-form-file>
            </b-form-group>

            <div class="full-width text-center mt-3">
              <b-button type="submit" variant="primary" >Save</b-button>
            </div>

          </form>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>

import FolderChildren from "./FolderChildren.vue";
export default {
  props:['access'],
    components:{FolderChildren},
    data() {

        let sortOrders = {};
        let columns = [
                        {label: 'Name', name: 'name' },
                        {label: 'Updated By', name: 'uploaded_by'},
                        {label: 'File Type', name: 'file_type'},
                        {label: 'File Size', name: 'file_size'},
                        {label: 'Last Modified', name: 'last_modified'},
                    ];
        columns.forEach((column) => {sortOrders[column.name] = -1;});

        return {
            types:{'pf':'Provident' , 'gf':'Gratuity' , 'wf':'Welfare'},
            editMode: false,
            folders: [],
            subfolders: [],
            files: [],
            selectedFolderId: null,
            newFolderName: '',
            parentId: null,
            password:'',
          // Mustafijur
            search: '',
            sortOrders: sortOrders,
            columns: columns,
            data: [],
            length : 20,
            pagination : {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
            blankmsg : 'Folder is empty...',
            sortKey: '',
            loading:'',
            file_id: null,
            showoverlaymodal : false,
            folder_options: [],
            parent_collapsed: {},
            // openSubfolderId: null,

            trusteeIsSelected: false,
            hasChildren:false,
            departments_option: [],
            departments: [],
            selected: [],
            selectedForDelete:null,
            selectedForEdit:null,
            allSelected: false,
            indeterminate: false,
            allFolders:[],
            navigator: [],
            selectedFolders:[],
            fdata: {},
            is_truestee: [],
            people:0,
            temp_length: 20,
            collapsed: {},
            modalTitle: 'Create New Folder',
            length_options : [{ value: 20, text: "20" },
                            { value: 50, text: "50" },
                            { value: 100, text: "100" },],

            };
        },
    created() {
        this.init()
        this.getDepartments();
    },
    methods: {
      getFileType(mime) {
          if (mime.startsWith("image/")) return "Image";
          else if (mime.startsWith("video/")) return "Video";
          else if (mime.startsWith("audio/")) return "Audio";
          else if (mime.includes("excel")) return "Excel";
          else if (mime.includes("word")) return "Word";
          else if (mime.includes("pdf")) return "PDF";
          else if (mime.includes("zip") || mime.includes("rar") || mime.includes("7z")) return "Archive";
          else return "File";
        },


        toggle(id, type='Folder') {
            const path = this.findPathToNode(this.allFolders, id);
            const pathIds = path.map(val => val.id);

            for (const key in this.collapsed) {
              this.$set(this.collapsed, key, false);
            }
            pathIds.forEach(pathId => {
              this.$set(this.collapsed, String(pathId), true);
            });
            this.$set(this.collapsed, String(id), !this.collapsed[id]);
            this.selectFolderTree(id);
        },


        findPathToNode(tree, targetId) {
            const path = [];
            function dfs(node, currentPath) {
                currentPath.push(node);

                if (node.id === targetId) {
                    path.push(...currentPath);
                    return true;
                }

                if (node.children) {
                    for (let child of node.children) {
                        if (dfs(child, [...currentPath])) {
                            return true;
                        }
                    }
                }

                return false;
            }

            for (let root of tree) {
                if (dfs(root, [])) break;
            }
            return path;
        },

        init(){
            this.resetTree()
            this.selectedFolderId = null
            axios.get(this.$api_url + '/' + this.access + '/filemanagement/folders/all').then(response=> {
                this.allFolders = response.data
                this.selectedFolders = this.allFolders.filter((folder)=> folder.parent_id==null);
            });
        },
        getFolders(){
            axios.get(this.$api_url+'/' + this.access + '/filemanagement/folders/all').then(response=> {
                this.allFolders = response.data
            });
        },

      // selectFolder(folderId){
      //     this.navigator.push(folderId)
      //     this.selectedFolderId = folderId;
      //   this.selectedFolders = this.selectedFolders.find((folder)=> folder.id===folderId).children;
      // },

        formatDate(dateObj) {
            const date = new Date(dateObj);
            const twoDigit = (num) => num.toString().padStart(2, '0');

            const year = twoDigit(date.getFullYear() % 100); // Last two digits of year
            const month = twoDigit(date.getMonth() + 1);     // Months are 0-indexed
            const day = twoDigit(date.getDate());

            let hours = date.getHours();
            const minutes = twoDigit(date.getMinutes());
            const ampm = hours >= 12 ? 'PM' : 'AM';

            hours = hours % 12;
            hours = hours ? hours : 12; // '0' hours should be '12'

            return `${year}-${month}-${day} ${twoDigit(hours)}:${minutes} ${ampm}`;
        },

        selectFolderTree(id){
            // let tree = null;
            // this.navigator.push(id)
            this.selectedFolderId = id;
            axios.get(this.$api_url+'/' + this.access + '/filemanagement/folders',{
                params: {
                    parent_id: encodeURIComponent(btoa(id))
                }
            }).then(response => {
                this.selectedFolders = response.data.folders
            })
        },
        resetTree(){
            this.collapsed = Object.fromEntries(
                Object.keys(this.collapsed).map(key => [key, false])
            );
        },

      traverseTree(nodes, callback) {
            nodes.forEach(node => {
                callback(node);
                if (Array.isArray(node.children) && node.children.length > 0) {
                    this.traverseTree(node.children, callback);
                }
            });
        },

      async createFolder() {
          const valid = await this.$validator.validateAll();
          if (!valid) {
              return;
          }
          try {
              if (this.trusteeIsSelected) this.selected = [];
              this.fdata.departments = this.selected;

              const response = await axios.post(this.$api_url + '/' + this.access + '/filemanagement/folders/create', {
                  id: this.editMode ? this.selectedForEdit : null,
                  name: this.newFolderName,
                  parent_id: this.selectedFolderId,
                  fdata: this.fdata,
                  trustee_member: this.trusteeIsSelected,
              });


              if(this.editMode){
                  if(this.selectedFolderId == null){
                      this.init()
                  }
                  const res = response.data.folder
                  const index = this.selectedFolders.findIndex(val => val.id === this.selectedForEdit);
                  this.selectedFolders[index].name = res.name
                  this.selectedFolders[index].uploaded_by = res.uploaded_by
                  this.selectedFolders[index].last_modified = res.last_modified

                  this.$bvToast.toast(response.data.message,{
                      variant:'success',
                      title:'Success',
                      solid: true
                  })
              }
              else{
                  this.selectedFolders.push(response.data.folder);
              }
              this.$bvModal.hide('bv-modal-create-folder');
              this.showoverlaymodal = false;
              this.newFolderName = '';
              this.parentId = null;
              this.getFolders();
          } catch (error) {
              if (error.response && error.response.status === 409) {
                  this.$bvToast.toast('Folder Name Already Exists', {
                      variant: 'danger',
                      title: 'Error',
                      solid: true
                  });
              }
              if(this.editMode){
                  this.$bvToast.toast('Can not update folder.', {
                      variant: 'danger',
                      title: 'Error',
                      solid: true
                  });
              }
              else{
                  this.$bvToast.toast('Can not create folder.', {
                      variant: 'danger',
                      title: 'Error',
                      solid: true
                  });
              }
          }
      },


    async uploadFile() {

      if (!this.$refs.fileInput.files.length) {
        this.$bvToast.toast('Please choose a file to upload.', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
        return;
      }

      const formData = new FormData();
      formData.append('file', this.$refs.fileInput.files[0]);
      try {
        var folderId = encodeURIComponent(btoa(this.selectedFolderId));
        const response = await axios.post(this.$api_url+'/' + this.access + `/filemanagement/folders/${folderId}/upload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        this.selectedFolders.push(response.data.file);
        this.$bvModal.hide('bv-modal-upload-file');
        this.showoverlaymodal = false;
        // this.fetchFiles(this.selectedFolderId); // Refresh the file list
        this.$refs.fileInput.value = null; // Clear input field

        if(response.data.message)
          {
            this.$bvToast.toast('Success!', {
                title: `Success`,
                variant: 'success',
                solid: true
            });
          }
          else
          {
            this.$bvToast.toast(response.data.message, {
                title: `error`,
                variant: 'danger',
                solid: true
            });
          }
      } catch (error) {
        console.error('Error uploading file:', error);
      }
        this.getFolders()

    },

    showFolder(){
      this.newFolderName = '';
      this.selected = [];
      this.editMode = false;
      this.trusteeIsSelected = false;
        this.selectedForEdit = null;
      this.modalTitle = 'Create New Folder';
      this.$bvModal.show('bv-modal-create-folder');
    },
    updateFolder(selectedFolderId){
      this.editMode = true
      this.selectedForEdit = selectedFolderId;
      axios.get(`${this.$api_url}/${this.access}/filemanagement/folder/details/${encodeURIComponent(btoa(selectedFolderId))}`).then(response => {

        this.newFolderName = response.data.folder.name;
        if(response.data.folder.trustee_member == null){
            this.trusteeIsSelected = false
        }
        else{
            this.trusteeIsSelected = response.data.folder.trustee_member == 1
        }

        this.selected = response.data.folder.departments;
        this.modalTitle = 'Edit Folder Name'
        this.$bvModal.show('bv-modal-create-folder');
      })
      .catch(error => {
        console.error("Failed to fetch folder:", error);
      });
    },

    showDeleteModal: function(folder){
        this.search = '';
          this.hasChildren = false;
          if(folder.file_type == 'Folder'){
              axios.get(this.$api_url + '/' + this.access + '/filemanagement/files/check',{
                  params:{
                      folder_id: folder.id
                  }
              }).then((response)=>{
                  if(response.data.data){
                      this.hasChildren = response.data.data
                  }
                  this.selectedForDelete = folder
                  this.$bvModal.show('delete-modal');
              })
          }
          else{
              this.hasChildren = false;
              this.selectedForDelete = folder
              this.$bvModal.show('delete-modal');
          }
        this.search = '';
    },

    deleteFile: async function(folder){

      this.search = ''
      let currentObj=this;
      this.loading='load';

      let formData = new FormData();
      let file_type = 'folder'
        if(folder.file_type != 'Folder'){
            file_type = 'file';
        }
      formData.append('file_id', folder.id);
      formData.append('type', file_type);

      await axios.post(this.$api_url+'/' + this.access + '/filemanagement/file/delete', formData)
        .then(function (response)
        {
          this.loading='';
          this.$bvModal.hide('delete-modal');
          this.showoverlaymodal = false;
          if(response.data.status){
              this.selectedFolders = this.selectedFolders.filter(item => item.id !== folder.id);
              this.$bvToast.toast(response.data.message, {
                  title: `Success`,
                  variant: 'success',
                  solid: true
              });
          }else{
              this.$bvToast.toast(response.data.message, {
                  title: `Error`,
                  variant: 'danger',
                  solid: true
              });
          }
          currentObj.password = ''



        }.bind(this))
        .catch(function (error)
        {
          currentObj.showoverlay = false;
          currentObj.serverError(error);
        });
        this.search = ''
      this.getFolders()
    },

    uploadFiles(){
      this.$bvModal.show('bv-modal-upload-file');
    },
    async downloadFile(fileId) {
      try {

        var encodedFileId = encodeURIComponent(btoa(fileId));

        const { data, headers } = await axios.get(this.$api_url+'/' + this.access + `/filemanagement/files/${encodedFileId}/download`, { responseType: 'blob' });

        const filename = headers['content-disposition']
          .split('filename=')[1]
          .replace(/['"]/g, '').trim();

        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(new Blob([data]));
        downloadLink.download = filename;
        downloadLink.click();
      } catch (error) {
        console.error('Error downloading file:', error);
      }
    },
    toggleAll(checked) {
          if(checked) {
              this.selected = this.departments.slice()
          }else{
              this.selected = []
          }

    },
    getDepartments: function () {

      if (!this.checkNet()) return false;
      let currentObj = this;
      axios.get(this.$api_url + '/department/list/details').then(function (response) {

          this.departments_option = response.data.depertments;
          this.departments = response.data.ids;

      }.bind(this)).catch(function (error) { currentObj.serverError(error); });

    },

    folderOpenToggle(folderId){
      // Toggle the collapse state for the clicked folder
      if(folderId != null){

        Object.keys(this.parent_collapsed).forEach(id => {
          if (id !== folderId.toString()) {
            this.parent_collapsed[id] = false; // Collapse other folders
          }
        });

        this.parent_collapsed[folderId] = true;

      }
      else {

        Object.keys(this.parent_collapsed).forEach(id => {
          this.parent_collapsed[id] = false;
        });

        this.selectedFolderId = null;
      }
    },

  },
  watch: {
    selected(newValue, oldValue) {
        // Handle changes in individual flavour checkboxes
        if (newValue.length === 0) {
            this.indeterminate = false
            this.allSelected = false
        } else if (newValue.length === this.departments.length) {
            this.indeterminate = false
            this.allSelected = true
        } else {
            this.indeterminate = true
            this.allSelected = false
        }
    }
  },
  computed: {

    filteredData()
    {
      let filtered_list = this.selectedFolders;
      if (this.search)
      {
        filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

        if(filtered_list.length == 0)
            this.blankmsg = "Nothing found.";
      }

      let sortKey = this.sortKey;
      let order = this.sortOrders[sortKey] || 1;
      if (sortKey)
      {
        filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
          a = String(a[sortKey]).toLowerCase();
          b = String(b[sortKey]).toLowerCase();
          if (this.columns[index].type && this.columns[index].type === 'date')
          {
              return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
          }
          else if (this.columns[index].type && this.columns[index].type === 'number')
          {
              return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
          }
          else
          {
              return (a === b ? 0 : a > b ? 1 : -1) * order;
          }
        });
      }

      this.people = filtered_list.length;

      return filtered_list;
    },

    paginatedData()
    {
      return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
    },
    // folderOptions() {

    //   this.folder_options = [{ value: '', text: 'Select Folder' }, ...this.folders.map(folder => ({ value: folder.id, text: folder.name }))];

    //   if(this.folder_options.length > 1){
    //     this.parentId = this.folder_options[1].value;
    //   }
    //   else {
    //     this.parentId = null;
    //   }

    //   return this.folder_options;
    // }
  }
};
</script>

<style scoped>
  /* Add your CSS here */
</style>


